import Vue from "vue"
import apiClient from "@/utils/cb-client"
import CBNotification from "@/models/cb-notification";
import HostedPageHelper from '@/utils/hosted-page-helper'
import {
  hostedPageState,
  hostedPageActions,
  hostedPageMutations,
  hostedPageGetters,
  SET_LOADED, SET_PARTIALLY_LOADED} from "@/store/common/hosted-page"

import {EventBus} from '@/utils/event-bus'

const state = {
  ...hostedPageState
}

const actions = {
  ...hostedPageActions,
  fetch_data({commit, state, dispatch, rootState, getters}, token) {
    // If hosted page type is checkout
    // link customer and cart details with order
    return Promise.all([
      dispatch('_fetch_data', token),
      dispatch('load_checkout_config')
    ]).then(() => {
      if(rootState.auth.authenticated) {
        logger.addMetaData('customer_handle', rootState.auth.customer_handle);
        // this will add shipping address subscription from hosted page to order
        dispatch('_after_fetch');
        dispatch('determine_steps');
        if(!(getters.one_screen_checkout || getters.skip_cart)){
          commit(SET_PARTIALLY_LOADED, true);
        }
        state.loading = dispatch('init_returning_user',
          {
            // For gift checkout don't load shipping address list
            skipShippingAddressList: getters.is_checkout_gift || !(rootState.config.review_steps.indexOf("shipping_address") > -1
              || rootState.config.review_steps.indexOf("billing_address") > -1)
          }
        );
        state.loading.then(() => {
          // if no billing address is present, use billing address from hosted page
          if(Object.keys(rootState.customer.billing_address).length == 0) {
            dispatch('add_billing_address', {data: state.data.billing_address, skip_est_calc: true});
          }
          // override customer data present in hosted page
          if(!getters.is_checkout_gift && Object.keys(state.data.customer).length > 0) {
            dispatch('override_customer_data', state.data.customer);
          }
          // this will add customer's shipping address if no shipping address is present
          dispatch('add_customer_details_to_order', {subscription_pm_id: state.data.subscription_pm_id});
          dispatch('determine_steps');
          logger.i({steps_page_load: rootState.config.steps});
          logger.i({review_steps_page_load: rootState.config.review_steps});
          commit(SET_PARTIALLY_LOADED, true);
          commit(SET_LOADED, true);
        }).catch((error) => logger.e(error));
      }
      else {
        commit(SET_PARTIALLY_LOADED, true);
        commit(SET_LOADED, true);
        if(!getters.is_checkout_gift) {
          dispatch('add_customer_data', state.data.customer);
        }
        if(state.data.billing_address && Object.keys(state.data.billing_address).length > 0) {
          dispatch('add_billing_address', {data: state.data.billing_address, skip_est_calc: true});
        }
        dispatch('_after_fetch');
        dispatch('add_customer_details_to_order', {new_customer: true});
        dispatch('determine_steps');
        logger.i({steps_page_load: rootState.config.steps});
        logger.i({review_steps_page_load: rootState.config.review_steps});
      }
    })
    .catch((error) =>  {
      logger.e(error);
    });
  },

  _after_fetch({commit, state, dispatch, rootState, getters}) {
    if(state.data.shipping_address) {
      dispatch('resolve_and_add_shipping_address', state.data.shipping_address);
      dispatch('set_shipping_address_to_order', {shipping_address: state.data.shipping_address, skip_est_calc: true});
    }
    // should we remove plan and plan quantiry from this ???
    !this.getters.is_checkout_one_time && dispatch('add_subscription_fields', Object.keys(state.data.subscription).reduce((p,n) => {
      if(["plan_id", "plan_quantity", "plan_quantity_in_decimal"].indexOf(n) == -1) {
        p[n] = state.data.subscription[n];
      }
      return p;
    }, {}));
    // initially setting this to true/false
    // this will be reset inside sections resolver
    dispatch('enable_copy_to_billing', !getters.is_checkout_gift && rootState.config.checkout_new.sections.shipping_address.use_billing_address)
    dispatch('add_order_item', {orderItem: HostedPageHelper.constructOrderItems(state.data, getters)}).then(()=>{
      EventBus.$emit("hp_log",{action:'init'});
    }).catch(error => {
      dispatch('set_current_notification', new CBNotification('error', error));
      logger.e(error);
    });;
  }
}

const mutations = {
  ...hostedPageMutations
}

const getters = {
  ...hostedPageGetters,
  subscription_handle: state => state.data && state.data.subscription_handle,
  subscription_data: state => state.data,
}

export default {
  state,
  actions,
  mutations,
  getters
}